import React from "react";
import { inject, observer } from "mobx-react";
import { ValidatedValue } from "../../../helpers/validator";
import TextInput from "../../sharedComponents/textInput/textInput";
import { RatesFailureReason, StoreCalculationService } from "../../../services/services/storeCalculationService";
import "./storeCalculationPopupContent.scss";
import Loader from "../../sharedComponents/loader/Loader";
import Notification from "../../sharedComponents/notification/notification";
import { HttpError } from "../../sharedComponents/notification/httpError";


interface StoreCalculationPopupContentProps {
  saveName: ValidatedValue<string>;
  storeCalculationService?: StoreCalculationService;
  displayPolicyUnavailable: boolean;
  saveButtonClicked?: boolean;
}

@inject("storeCalculationService")
@observer
export default class StoreCalculationPopupContent extends React.Component<StoreCalculationPopupContentProps, any> {
  public render() {
    return (
      <div className={`popup-content-container`}>
        {this.renderContent()}
      </div>
    );
  }

  private renderContent() {
    if (this.props.storeCalculationService!.requestStatus.isError) {
      return this.renderErrorContent();
    } else if (!!this.props.storeCalculationService!.storeCalculationResponse.calculationId) {
      return this.renderSuccessContent();
    } else if (this.props.storeCalculationService!.requestStatus.isPending || this.props.saveButtonClicked) {
      return this.renderPendingContent();
    } else if (this.props.displayPolicyUnavailable) {
      return this.renderPolicyUnavailable();
    } else {
      return (<div className="action">{this.renderAction()} </div>);
    }
  }

  private renderPolicyUnavailable() {
    return (
      <span className="policy-unavailable">
        Z zapisywanej kalkulacji nie będzie można wystawić polisy, czy chcesz kontynuować?
      </span>
    );
  }

  private renderErrorContent() {
    return (
      <div>
        <Notification type="error" message={"Wystąpił błąd podczas zapisu kalkulacji."} className="error" />
        <HttpError type={"error"} requestStatuses={[this.props.storeCalculationService!.requestStatus]} />
      </div>
    );
  }

  private renderSuccessContent() {
    const calculationId = this.props.storeCalculationService!.storeCalculationResponse.calculationId;
    const ratesStored = this.props.storeCalculationService!.storeCalculationResponse.ratesStored;
    const ratesFailureReason = this.getFailureMessage(this.props.storeCalculationService!.storeCalculationResponse.ratesFailureReason);

    const calculationNumberText = "Numer kalkulacji : " + calculationId;
    const ratesErrorText = ratesStored === false ? (ratesFailureReason !== undefined
      ? `Wydruk kalkulacji będzie możliwy po udzieleniu odpowiedzi na pytania w sekcji: "Dodatkowe pytania w celu doszczegółowienia oferty": "${ratesFailureReason}". Uzupełnij pola, przelicz składkę i zapisz kalkulację.`
      : `Wydruk kalkulacji będzie możliwy po udzieleniu odpowiedzi na wymagane pytania. Uzupełnij pola, przelicz składkę i zapisz kalkulację.`) : null;

    return (<div className="success">
      <div>{calculationNumberText}</div>
      {!!ratesErrorText ? (<div className="rates-error">{ratesErrorText}</div>) : ""}
    </div>);
  }

  private getFailureMessage(ratesFailureReason?: RatesFailureReason) {
    if (!ratesFailureReason) {
      return "";
    }
    if (ratesFailureReason.partnerApiErrorCodes) {
      return ratesFailureReason.partnerApiErrorCodes.join(", ");
    } else {
      return ratesFailureReason.oldApiMessage;
    }
  }

  private renderPendingContent() {
    return (<div className="pending">
      <span className="pending-text">
        Trwa zapisywanie kalkulacji...
      </span>
      <Loader />
    </div>);
  }

  private renderAction() {
    return (
      <>
        <div className={"content-text-container"}>Wpisz nazwę kalkulacji</div>
        <div className="input-container">
          <TextInput className="popup-text-input"
            validatedValue={this.props.saveName}
          />
        </div>
      </>
    );
  }
}
